import { Component } from '@angular/core';
import { NavController } from 'ionic-angular';
import { EntrarPage } from '../entrar/entrar';
import { CarregandoPage } from '../carregando/carregando';
import { AuthService } from '../../providers/auth-service';

@Component({
  selector: 'page-home',
  templateUrl: 'home.html'
})
export class HomePage {
	public entrarPage = EntrarPage;

	constructor(public navCtrl: NavController, private auth: AuthService) {}

	ionViewWillEnter(){
		if(localStorage.getItem("idUsuario")){
			this.auth.getData();
			this.navCtrl.setRoot(CarregandoPage);
			return false;
		}
	}

	public entrar(){
	    this.navCtrl.push(EntrarPage);
	}
}


// WEBPACK FOOTER //
// ./src/pages/home/home.ts